module.exports = __webpack_public_path__ + "img/subline-only_1.b1cf4d78.svg";